import * as React from "react";

import style from "./AlertModal.module.scss";

export interface AlertModalProps {
  callback: () => void;
  content: string | React.ReactElement;
  textBtnOk?: string;
  closeModal: () => void;
}

export const AlertModal = (props: AlertModalProps) => {
  return (
    <main className={style.main}>
      <div className={style.header}>
        <div className="mb-3">{props.content}</div>
      </div>
      <div className={style.body}>
        <div className={style.btnArea}>
          <button
            className={"btn " + style.okBtn}
            onClick={() => {
              props.callback();
              props.closeModal();
            }}
          >
            {props.textBtnOk ?? "OK"}
          </button>
        </div>
      </div>
    </main>
  );
};

export default AlertModal;
